// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"e4","newsTag":"e4","dafalut":"e5","qishou":"e6","shangjia":"e7","shehui":"e8","caiwu":"e9","piyao":"e-","suanfa":"e_","keji":"fa","lingshou":"fb","gongzuo":"fc"};